import React, { useEffect, useRef, useState } from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import {
  Box,
  CircularProgress,
  Container,
  IconButton,
  Modal,
  Pagination,
  Snackbar,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material"
import searchtopicIcon from "../images/newIcons/searchtopicIcon.svg"
import CloseIcon from "@mui/icons-material/Close"
import * as allImages from "../utils/images"
import { API_URL } from "../utils/config"
import axios from "axios"
import { InfoMessage, headers } from "../utils/utils"
import downloadicon from "../images/newIcons/downloadicon.svg"
import {
  MdArrowBack,
  MdArrowForward,
  MdPreview,
} from "react-icons/md"
import HTMLFlipBook from "react-pageflip"
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch"

interface exclusiveTemplateProps {
  pageContext: {
    id: string
    title: string
  }
}

const Magazine: React.FC<exclusiveTemplateProps> = ({ pageContext }) => {
  const [value, setValue] = useState<string>("")
  const [loadingId, setLoadingId] = useState("")
  const [infoMessage, setInfoMessage] = useState({} as InfoMessage)
  const [open, setOpen] = React.useState(false)
  const [showField, setShowField] = useState<boolean>(false)
  const [filterdata, setFilterData] = useState<Array<object>>(pageContext[0])
  const [data, setData] = useState<any>(pageContext[0])
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"))

  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      setData(
        filterdata.filter(
          (ele: any) =>
            ele.title.toLowerCase().includes(e.target.value.toLowerCase()) ||
            (typeof ele.title === "string" &&
              ele.title
                ?.toLowerCase()
                .includes(e.target.value.toLowerCase())) ||
            (Array.isArray(ele.title) &&
              ele.title.some((ch: any) =>
                ch.toLowerCase().includes(e.target.value.toLowerCase())
              )) ||
            (typeof ele.searchText === "string" &&
              ele.searchText
                ?.toLowerCase()
                .includes(e.target.value.toLowerCase())) ||
            (Array.isArray(ele.searchText) &&
              ele.searchText.some((ch: any) =>
                ch.toLowerCase().includes(e.target.value.toLowerCase())
              ))
        )
      )
    }
  }

  const getExclusives = async (id: string, title: string) => {
    setLoadingId(id)
    try {
      const payload = {
        FileName: `${id}.pdf`,
      }
      await axios
        .post(`${API_URL}/download/magazine`, payload, { headers })
        .then((res: any) => {
          if (res.data.status === 200) {
            setInfoMessage({ message: "", status: res.data.status })
            setOpen(true)
            const byteArray = Uint8Array.from(
              atob(res.data?.base64Content),
              char => char.charCodeAt(0)
            )
            const blob = new Blob([byteArray], { type: "application/pdf" })

            try {
              const link = document.createElement("a")
              link.href = window.URL.createObjectURL(blob)
              link.download = `${title}.pdf`
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)
            } catch (error) {
              console.error("Error creating or triggering download:", error)
            }
          }
        })
        .catch(error => {
          setOpen(true)
          setInfoMessage({
            message: error.response.data.message
              ? error.response.data.message
              : error.message,
            status: error.response.data.status,
          })
        })
        .finally(() => {
          setLoadingId("")
        })
    } catch (err) {
      console.log(err)
      setInfoMessage({ message: "Downloading error" })
    }
  }

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    setOpen(false)
  }

  const handleFetchImage = (item: any) => {
    let fileName = item
    let fileNameWithoutExtension = fileName.replace(".png", "")
    let camelCaseName: string = fileNameWithoutExtension.replace(
      /[-_](.)/g,
      (_: any, char: any) => char.toUpperCase()
    )
    return allImages[`thumb${camelCaseName}`] || ""
  }

  //flipbook js
  const [flipOpen, setFlipbookOpen] = useState(false)
  const [flipbookImageList, setflipbookImageList] = useState([""])
  const flipbookRef = useRef(null);

  const handleFlipbookOpen = (magazineImageList: any) => {
    setFlipbookOpen(true);
    getFlipbookImageList(magazineImageList);
  }
  const handleFlipbookClose = () => setFlipbookOpen(false)

  const getFlipbookImageList = (magazineImageList: any) => {
    const flipbookImages:string[] = [];
    magazineImageList.map((img: string) => {
      flipbookImages.push(img);
    })
    setflipbookImageList(flipbookImages);
  }

  const getMagazineImage = (imgSrc: string) => {
    return allImages[imgSrc] || ""
  }

  const [bookHeight, setBookHeight] = useState(850)
  const [bookWidth, setBookWidth] = useState(400)

  useEffect(() => {
    const handleResize = () => {
      const availableHeight = window.innerHeight - 30
      setBookHeight(isMobile ? 250 : Math.min(availableHeight, 850))
      const availableWidth = window.innerWidth - 1310
      setBookWidth(isMobile ? window.innerWidth/2.5 
        : (window.innerWidth < 1500 && window.innerWidth >= 1400) ? window.innerWidth - 975 
          : (window.innerWidth < 1700 && window.innerWidth >= 1600) ? window.innerWidth - 1095
            : (window.innerWidth < 1800 && window.innerWidth >= 1700) ? window.innerWidth - 1165
              : Math.max(availableWidth, 400))
    }

    handleResize() // Run once on mount
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return (
    <Layout>
      <Snackbar
        open={open}
        autoHideDuration={2000}
        onClose={handleClose}
        message={
          infoMessage.status === 200
            ? "PDF Downloaded succesfully"
            : infoMessage.message
        }
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{
          ".MuiSnackbarContent-root": {
            backgroundColor: infoMessage.status === 200 ? "#43a047" : "#ff3333",
            fontWeight: "700",
          },
        }}
      />

      {/* Flipbook Modal */}
      <Modal open={flipOpen} onClose={handleFlipbookClose} className="flipbook-modal">
        {isMobile ? <>
          <Box sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: "calc(100vh - 20px)",
            padding: 2,
            scrollBehavior: "smooth",
            overflowY: "scroll",
            WebkitOverflowScrolling: "touch",
            '&::-webkit-scrollbar': {
              width: '6px',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#236ca3',
              borderRadius: '3px',
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: '#f1f1f1',
            },
          }}>
            <Box fontStyle="italic" fontSize={12} color="#fff" textAlign="center" marginBottom="15px">
              Scroll to view all pages
            </Box>
            {flipbookImageList.map((imgSrc, index) => (
            <img
              key={index}
              src={getMagazineImage(imgSrc)}
              alt={`Page ${index + 1}`}
              style={{paddingBottom: 15,
                borderRadius: 4,
                maxWidth: "100%",
                height: "auto",}}
            />
            ))}
          </Box>
        </> 
        : <Box
          sx={{
            position: "relative",
            top: 15,
            left: isMobile ? 0 : 15,
            width: "97.5vw",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            // zIndex: 1500,
          }}
        >
          {/* Flipbook controls */}
          <IconButton
            onClick={handleFlipbookClose}
            sx={{
              position: "absolute",
              top: 16,
              right: isMobile ? 0 : 60,
              padding: isMobile ? "2px" : "8px",
              color: "#fff",
              backgroundColor: "rgb(35 108 165 / 80%)",
              zIndex: 2000,
              "&:hover": { backgroundColor: "rgb(35 108 165 / 95%)" },
            }}
          >
            <CloseIcon />
          </IconButton>
          <Typography 
            variant="h6" 
            fontStyle="italic" 
            fontSize={12} 
            color="#fff"
            textAlign="center"
            width="100px"
            sx={{ position: "absolute",
                  top: isMobile ? "100%" : "80px",
                  right: isMobile ? "38%" : "28px",
                  zIndex: 2000,
                }}
          >
            Pinch or scroll to Zoom In and Out
          </Typography>

          <Box>
            <button style={{ position: 'absolute', top: "48%", left: "14%", zIndex: 2, color: '#fff',borderRadius: "50%", padding: "12px 13px", backgroundColor: "rgb(35 108 165 / 80%)" }}
              onClick={() => {
                if (flipbookRef.current) {
                  // @ts-ignore
                  flipbookRef.current.pageFlip().flipPrev();
                }
              }}><MdArrowBack/></button>
            <button style={{ position: 'absolute', top: "48%", right: "14%", zIndex: 2, color: '#fff', borderRadius: "50%", padding: "12px 13px", backgroundColor: "rgb(35 108 165 / 80%)" }}
              onClick={() => {
                if (flipbookRef.current) {
                  // @ts-ignore
                  flipbookRef.current.pageFlip().flipNext();
                }
              }}><MdArrowForward/></button>
          </Box>

          {/* Flipbook */}
          <HTMLFlipBook
            ref={flipbookRef}
            // size="stretch"
            // width={600}
            // height={520}
            size="fixed"
            // width={400}
            // height={552}
            width={bookWidth}
            height={bookHeight}
            minWidth={315}
            maxWidth={1000}
            minHeight={400}
            maxHeight={1533}
            maxShadowOpacity={0.5}
            showCover={false}
            mobileScrollSupport={true}
            drawShadow={true}
            flippingTime={1000}
            useMouseEvents={true}
            swipeDistance={50}
            clickEventForward={true}
            usePortrait={false}
            startZIndex={0}
            autoSize={true}
            showPageCorners={true}
            disableFlipByClick={true}
            startPage={0}
            style={{}}
            className="flipbook"
          >
            {flipbookImageList.map((imgSrc, index) => (
              <div className="page" key={index}>
                {/* <div
                  className="zoom-wrapper"
                  style={{
                    transform: `scale(${zoomLevel})`,
                    transformOrigin: "center center",
                    transition: "transform 0.3s ease",
                  }}
                >
                  <img
                    src={imgSrc}
                    alt={`Page ${index + 1}`}
                    className="page-image"
                  />
                </div> */}
                <TransformWrapper
                  initialScale={1}
                  wheel={{ disabled: false }}
                  doubleClick={{ disabled: true }}
                  pinch={{ disabled: false }}
                  panning={{ disabled: false }}
                >
                  {({ zoomIn, zoomOut, resetTransform }) => (
                    <>
                      {/* Optional per-image controls */}
                      {/* <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          position: "absolute",
                          top: 0,
                          left: "40%",
                          zIndex: 2000,
                        }}
                      >
                        <button style={{padding: 1, marginRight: 10}} title="Zoon In" onClick={() => zoomIn()}>+</button>
                        <button style={{padding: 1, marginRight: 10}} title="Zoon Out" onClick={() => zoomOut()}>−</button>
                        <button style={{padding: 1, fontSize: 12}} onClick={() => resetTransform()}>Reset</button>
                      </Box> */}

                      <TransformComponent>
                        <img
                          src={getMagazineImage(imgSrc)}
                          alt={`Page ${index + 1}`}
                          className="page-image"
                        />
                      </TransformComponent>
                    </>
                  )}
                </TransformWrapper>
              </div>
            ))}
          </HTMLFlipBook>
        </Box>}
      </Modal>
      <Seo
        title="The Bottom Line – Invimatic’s Corporate Magazine Celebrating People, Values & Growth"
        description="Discover The Bottom Line, Invimatic’s first-ever corporate magazine. Explore the inspiring stories, team achievements, workplace culture, and the values that define us."
        keywords="Invimatic corporate magazine"
      />
      <section>
        <div className="magazineBanner">
          <Stack
            alignItems="center"
            textAlign="center"
            sx={{ position: "relative", zIndex: 1, color: "#fff" }}
          >
            <Typography
              variant="h1"
              fontSize={isMobile ? 32 : 42}
              fontWeight={isMobile ? 600 : 700}
              ml={2}
              mr={2}
              mt="60px"
            >
              <b>The Bottom Line</b>
              <br />
              Our Culture. Our Story. Our Values.
            </Typography>
          </Stack>
        </div>
      </section>

      <section className=" casestudy-wrapper section-wrapper blogs-wrapper news-blog-wrapper">
        <Container className="mainWrapper" maxWidth="xl">
          <Stack
            direction="row"
            alignItems={isMobile ? "center" : "baseline"}
            justifyContent="space-between"
            pb={isMobile ? 2 : 0}
          >
            {isMobile ? (
              <>
                {showField ? (
                  <TextField
                    id="standard-basic"
                    variant="standard"
                    placeholder="Search Topic"
                    value={value}
                    onKeyDown={handleKeyDown}
                    onChange={e => setValue(e.target.value)}
                    sx={{
                      pb: isMobile ? 2 : 6,
                      "& .MuiInputBase-input": {
                        color: "#fff",
                        width: 350,
                      },
                      "& .MuiFormLabel-root": { color: "#fff" },
                      "& .MuiInput-underline:before": {
                        borderBottom: "1px solid #fff",
                      },
                      "& .MuiInput-underline:after": {
                        borderBottom: "1px solid #fff",
                      },
                      ".MuiInputBase-root:hover:not(.Mui-disabled, .Mui-error):before":
                        { borderBottom: "1px solid #fff" },
                    }}
                    InputProps={{
                      startAdornment: (
                        <IconButton
                          sx={{ color: "#000", p: 0, mr: 1 }}
                          aria-label="search Topic"
                        >
                          <img src={searchtopicIcon} alt="search icon" />
                        </IconButton>
                      ),

                      endAdornment: (
                        <IconButton aria-label="clear search">
                          {value && (
                            <CloseIcon
                              sx={{ color: "#7B889F", p: 0, width: "18px" }}
                              onClick={() => {
                                setShowField(false)
                                setValue("")
                                setData(filterdata)
                              }}
                            />
                          )}
                        </IconButton>
                      ),
                    }}
                  />
                ) : (
                  <IconButton
                    sx={{ color: "#000", p: 0, mr: 1 }}
                    aria-label="search Topic"
                    onClick={() => setShowField(true)}
                  >
                    <img src={searchtopicIcon} alt="search icon" />
                  </IconButton>
                )}
              </>
            ) : (
              <TextField
                id="standard-basic"
                variant="standard"
                placeholder="Search Topic"
                value={value}
                onKeyDown={handleKeyDown}
                onChange={e => setValue(e.target.value)}
                sx={{
                  pb: isMobile ? 2 : 6,
                  "& .MuiInputBase-input": { color: "#fff", width: 350 },
                  "& .MuiFormLabel-root": { color: "#fff" },
                  "& .MuiInput-underline:before": {
                    borderBottom: "1px solid #fff",
                  },
                  "& .MuiInput-underline:after": {
                    borderBottom: "1px solid #fff",
                  },
                  ".MuiInputBase-root:hover:not(.Mui-disabled, .Mui-error):before":
                    { borderBottom: "1px solid #fff" },
                }}
                InputProps={{
                  startAdornment: (
                    <IconButton
                      sx={{ color: "#000", p: 0, mr: 1 }}
                      aria-label="search Topic"
                    >
                      <img src={searchtopicIcon} alt="search icon" />
                    </IconButton>
                  ),

                  endAdornment: (
                    <IconButton aria-label="clear search">
                      {value && (
                        <CloseIcon
                          sx={{ color: "#7B889F", p: 0, width: "18px" }}
                          onClick={() => {
                            setValue("")
                            setData(filterdata)
                          }}
                        />
                      )}
                    </IconButton>
                  ),
                }}
              />
            )}
          </Stack>
          <div className="row">
            {data?.length ? (
              data?.map((ele: any) => (
                <div
                  key={ele.id}
                  className="col-lg-4 col-md-6 col-sm-12 col-12 custom-padding mb-4"
                >
                  <div
                    className="caseStudysection"
                    style={{ height: "100%", padding: 0 }}
                  >
                    <div
                      className="single-blog-box"
                      data-aos="fade-up"
                      data-aos-easing="linear"
                      data-aos-duration="400"
                    >
                      <div>
                        <div className="blog-image magazin-image">
                          <img
                            src={handleFetchImage(ele.id)}
                            className="img-fluid blog-thumb"
                            alt={ele.id}
                          />
                        </div>
                        <div className="blog-content" style={{ padding: 10 }}>
                          <Typography
                            variant="h4"
                            title={ele.title}
                            style={{ margin: "12px 0 6px" }}
                          >
                            {ele.title}
                          </Typography>
                          <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                          >
                            <Typography
                              variant="h6"
                              title={ele.date}
                              style={{ fontSize: 12, color: "#fff" }}
                            >
                              Posted on: {ele.date}
                            </Typography>
                            <IconButton
                              aria-label="View Magazine"
                              title="View Magazine"
                              sx={{ color: "#fff", padding: 0 }}
                              onClick={()=>handleFlipbookOpen(ele.magazineImageList)}
                            >
                              <MdPreview />
                            </IconButton>
                          </Stack>
                          <div
                            className="commonBtn"
                            style={{
                              fontWeight: "700",
                              margin: "20px auto",
                              padding: "5px 12px",
                              cursor: "pointer",
                            }}
                            onClick={() => getExclusives(ele.id, ele.title)}
                          >
                            Download
                            {loadingId === ele.id ? (
                              <Stack
                                sx={{
                                  alignItems: "center",
                                  ".MuiCircularProgress-indeterminate": {
                                    width: "20px !important",
                                    height: "20px !important",
                                    marginTop: "5px",
                                  },
                                }}
                              >
                                <CircularProgress
                                  sx={{
                                    ".MuiCircularProgress-circle": {
                                      color: "#fff !important",
                                    },
                                  }}
                                />
                              </Stack>
                            ) : (
                              <img src={downloadicon} alt="Download" />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <Stack textAlign="center" display="flex" width="100%" pt={6}>
                <Typography variant="h4" color="white">
                  Coming Soon...
                </Typography>
              </Stack>
            )}
          </div>

          {isMobile ? (
            <Stack
              direction="row"
              alignItems="center"
              textAlign="center"
              justifyContent="center"
              gap={2.5}
            >
              <Stack spacing={2}>
                <Pagination
                  count={3}
                  variant="outlined"
                  sx={{
                    ".MuiButtonBase-root": {
                      margin: "0 10px",
                      color: "#FAFAFC",
                      border: "1px solid  #FFF",
                      "&.Mui-selected": {
                        color: "#FAFAFC",
                        background: "#236CA5",
                      },
                    },
                  }}
                />
              </Stack>
            </Stack>
          ) : (
            <></>
          )}
        </Container>
      </section>
    </Layout>
  )
}

export default Magazine
